export const APP_NAME = 'BuyMyCow';



// WEBPACK FOOTER //
// ./src/app/config/app.js